import { DaoModel } from './daoModel';

export class FrontRoute extends DaoModel {
  constructor(routes, functionalities) {
    super();
    this.routes = routes;
    this.functionalities = functionalities;
  }

  static toInstance(props = {}) {
    return new FrontRoute(props.routes, props.functionalities);
  }

  serialize() {
    return {
      ...super.serialize(),
      routes: this.routes,
      functionalities: this.functionalities,
    };
  }
}
